import { useState } from "react";

export default function useLimitedRowSelection() {
  const [selectedRows, setSelectedRows] = useState({
    type: "include",
    ids: new Set(),
  });

  const handleRowSelectionChange = (newModel) => { 
    const modelIds = Array.isArray(newModel) ? newModel : Array.from(newModel?.ids ?? []);

    setSelectedRows({
      type: "include",
      ids: new Set(modelIds),
    });
  };

  const clearSelection = () => {
    setSelectedRows({
      type: "include",
      ids: new Set(),
    });
  };

  return {
    selectedRows,
    handleRowSelectionChange,
    selectedCount: selectedRows.ids.size,
    clearSelection,
  };
}